import merge from 'lodash/merge';
import local from './local.jsx';
import test from './test.jsx';
import dev from './dev.jsx';
import prod from './prod.jsx';
import uni from './uni.jsx';

const settings = {
  LOCAL_ENCRYPTION_SECRET: 'Bdeh3#44%dw',
  PREAGG_TYPE:['rollup','rollupJoin','originalSql'],
  GRANULARITY:['day','week','month','quarter','year'],
  REFRESH_KEY:['dynamic','every'],
  defaultPreaggObj:{type:'rollup',refreshKeyValue:'dynamic'},
  defaultRefreshObj:{every: `12 hour`,updateWindow: '2 day',incremental: true}
}

export function getRandomName(length = 5) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result + (new Date().getTime().toString());
}

export const toCamelCase = (s, dataset = false) => {
  //console.log(s,dataset)
  let n = s.length;
  let str = "";
  for (let i = 0; i < n; i++) {
    if (dataset && i == 0) {
      str += s[i].toUpperCase();
    }
    else {
      if (s[i] == ' ' || s[i] == '_' || s[i] == '-' || s[i] === '.') {
        //console.log(s[i])
        if(s[i + 1]){
          str += s[i + 1].toUpperCase();
          i++;
        }       
      }
      else {
        str += s[i];
      }
    }
  }
  str = str.trim()
  return str;
}

export default (() => {
  switch (process.env.REACT_APP_ENV) {
    case 'dev':
      return merge(dev, settings)
    case 'test':
      return merge(test, settings)
    case 'prod':
      return merge(prod, settings)
    case 'uni':
      return merge(uni, settings)
    default:
      return merge(local, settings)
  }
})()
